import { render, staticRenderFns } from "./Ggzw.vue?vue&type=template&id=cf20bc14&scoped=true&"
import script from "./Ggzw.vue?vue&type=script&lang=js&"
export * from "./Ggzw.vue?vue&type=script&lang=js&"
import style0 from "./Ggzw.vue?vue&type=style&index=0&id=cf20bc14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf20bc14",
  null
  
)

export default component.exports